<template>
  <el-card>
    <el-row>
      <el-col :span="18">&nbsp;</el-col>
      <el-col :span="6">
        <el-button v-if="showAdd" type="primary" @click="addCompanyBranchOffice">添加子公司</el-button>
        <el-button type="primary" @click="goBack">返回</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col>

        <el-table
          :data="list"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="id">
            <template slot-scope="scope" >
              {{scope.row.id}}
            </template>
          </el-table-column>

          <el-table-column
            prop="branch_company_name"
            label="公司名称">
            <template slot-scope="scope" >
              {{scope.row.branch_office_name}}
            </template>
          </el-table-column>

          <el-table-column
            prop="branch_office_code"
            label="公司代码">
            <template slot-scope="scope" >
              {{scope.row.branch_office_code}}
            </template>
          </el-table-column>

          <el-table-column
            prop="remark"
            label="备注">
            <template slot-scope="scope" >
              {{scope.row.remark}}
            </template>
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="创建时间">
            <template slot-scope="scope">
              <span>{{scope.row.create_time | parseTime('{y}-{m}-{d}')}}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" content="查看">
                <el-button v-if="showView" type="text" @click="viewCompanyBranchOffice(scope.row.id)">
                  <i class="el-icon-view"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip effect="light" placement="top-start" content="编辑">
                <el-button v-if="showEdit" type="text" @click="editCompanyBranchOffice(scope.row.id)">
                  <i class="el-icon-edit"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip effect="light" placement="top-start" content="删除">
                <el-button v-if="showDelete" type="text" @click="deleteCompanyBranchOffice(scope.row.id)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip effect="light" placement="top-start" content="保险公司账户设置">
                <el-button v-if="showManageCompanyAccount" type="text" @click="manageCompanyAccount(scope.row.id)">
                  <i class="el-icon-s-cooperation"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip effect="light" placement="top-start" content="保险公司险种设置">
                <el-button v-if="showManageInsuranceType" type="text" @click="manageInsuranceType(scope.row.id)">
                  <i class="el-icon-s-operation"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip effect="light" placement="top-start" content="账单模型设置">
                <el-button v-if="showManageBillingModel" type="text" @click="manageBillingModel(scope.row.id)">
                  <i class="el-icon-set-up"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>

        </el-table>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import {
  fetchSettingCompanyBranchOfficeList,
  fetchSettingCompanyBranchOffice,
  createSettingCompanyBranchOffice,
  deleteSettingCompanyBranchOffice,
  updateSettingCompanyBranchOffice,
 } from '@/api/billing'
import { parseTime } from '@/utils'
export default {
  name: 'setting-company-branch-office-list',
  data() {
    return {
      company_id:0,
      showView: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      showManageCompanyAccount: false,
      showManageInsuranceType: false,
      showManageBillingModel: true,
      query: {
        offset: 0,
        limit: 20
      },
      loading: false,
      list: []
    }
  },
  methods: {
    goBack: function(){
      this.$router.go(-1)
    },
    addCompanyBranchOffice: function(){
      console.log('addCompanyBranchOffice()')
      this.$router.push({name: 'addSettingCompanyBranchOffice', query:{company_id: this.company_id}})
    },
    viewCompanyBranchOffice: function(id){
      console.log('viewCompanyBranchOffice(): id=' + id )
      this.$router.push({name: 'viewSettingCompanyBranchOffice', query: {id: id}})
    },
    editCompanyBranchOffice: function(id){
      console.log('editCompanyBranchOffice(): id=' + id )
      this.$router.push({name: 'editSettingCompanyBranchOffice', query: {id: id}})
    },
    deleteCompanyBranchOffice: function(id){
      console.log('deleteCompanyBranchOffice(): id=' + id )
      deleteSettingCompanyBranchOffice(id)
        .then(res=>{
          setTimeout(()=>{
            this.$message.success('成功删除公司信息')
            this.getList()
          }, 500)
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    manageCompanyAccount: function(branch_office_id){
      console.log('manageCompanyAccount('+ branch_office_id +')')
      this.$router.push({name: 'settingCompanyAccountList', query: {company_id:this.company_id, branch_office_id: branch_office_id}})
    },
    manageInsuranceType: function(branch_office_id){
      console.log('manageInsuranceType()')
      this.$router.push({name: 'settingInsuranceTypeList', query: {company_id:this.company_id, branch_office_id: branch_office_id}})
    },
    manageBillingModel: function(branch_office_id){
      this.$router.push({name: 'settingBillingModelList',
        query: {branch_office_id: branch_office_id}})
    },
    getList: function(){
      this.loading = true
      fetchSettingCompanyBranchOfficeList(this.query, this.company_id)
        .then( res => {
          this.list = res.results
          this.loading = false
        }).catch( err => {
          this.loading = false
          this.$error_message(err)
        })
    }
  },
  created() {
    if (this.$route.query.company_id === undefined || this.$route.query.company_id === null){
      this.$router.push('/404')
    }
    this.company_id = this.$route.query.company_id

    // 权限检查
    if (!this.$perm(["billing.list_setting_branch_office"])) {
      this.$router.push('/401')
    }
    this.showView = true

    if (this.$perm(["billing.create_setting_branch_office"])) {
      this.showAdd = true
    }

    if (this.$perm(["billing.update_setting_branch_office"])) {
      this.showEdit = true
    }

    if (this.$perm(["billing.delete_setting_branch_office"])) {
      this.showDelete = true
    }

    if (this.$perm(["billing.list_setting_company_account"])) {
      this.showManageCompanyAccount = true
    }

    if (this.$perm(["billing.list_setting_insurance_type"])) {
      this.showManageInsuranceType = true
    }

    this.getList()
  }
}
</script>
